import { Component, ViewEncapsulation } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CapturumColorPickerModule } from '@capturum/ui/color-picker';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-color-picker',
  imports: [CapturumColorPickerModule, ReactiveFormsModule],
  template: `
    <cap-color-picker [formControl]="formControl" [displayInput]="props.displayInput" appendTo="body" />
    @if (!props.displayInput) {
      <span class="color" [class.disabled]="props.disabled || props.readonly">{{ formControl.value }}</span>
    }
  `,
  encapsulation: ViewEncapsulation.None,
})
export class ColorPickerInputTypeComponent extends FieldType {}
